import React, { useState } from 'react';

function UrlUploader({ isOpenModalUrlUploader, onOpenModalUrlUploader, urlUploader, setUrlUploader }) {

    /* const [isOpenModalUrlUploader, setIsOpenModalUrlUploader] = useState(false);
    const [urlUploader, setUrlUploader] = useState(''); */

    const handleOpen = () => {
        setIsOpenModalUrlUploader(true);
    };

    const handleClose = () => {
        onOpenModalUrlUploader(false);
    };

    const handleChange = (e) => {
        setUrlUploader(e.target.value);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log(urlUploader);

        // POST запрос к серверу
        fetch('/api/downloadYoutube', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                // добавьте здесь другие необходимые заголовки
            },
            body: JSON.stringify({ url: urlUploader }),
        })
            .then(response => response.json())
            .then(data => console.log(data))
            .catch((error) => {
                console.error('Error:', error);
            });

        onOpenModalUrlUploader(false);
    };

    return (
        <div>
            {/* <button onClick={handleOpen} className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
                Открыть модальное окно
            </button> */}
            {isOpenModalUrlUploader && (
                <div className="fixed top-0 left-0 flex items-center justify-center w-full h-full bg-gray-800 bg-opacity-50 z-[999]">
                    <div className="bg-white rounded shadow-lg w-11/12 md:max-w-md mx-auto max-h-full overflow-y-auto">
                        <div className="py-4 text-left px-6">
                            <div className="flex justify-between items-center pb-3">
                                <p className="text-2xl font-bold">Введите URL</p>
                                <div className="cursor-pointer z-50" onClick={handleClose}>
                                    <svg className="fill-current text-black" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
                                        <path d="M18 1.3L16.7 0 9 7.7 1.3 0 0 1.3 7.7 9 0 16.7 1.3 18 9 10.3l7.7 7.7 1.3-1.3L10.3 9 18 1.3z" />
                                    </svg>
                                </div>
                            </div>
                            <form onSubmit={handleSubmit} className="flex flex-col items-center">
                                <input
                                    type='url'
                                    value={urlUploader}
                                    onChange={handleChange}
                                    required
                                    className="my-4 border rounded py-2 px-4 w-full"
                                />
                                <button
                                    type='submit'
                                    className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
                                    Отправить
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default UrlUploader;
